import { Datagrid, NumberField, ReferenceManyField, SimpleList, TextField } from "react-admin";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import DisplayDateField from "@/components/DisplayDateField";
import { formatListDate } from "@/utils/date-format";

export const ProjectShowInayatTab = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <ReferenceManyField reference="projectInayats" target="projectId" label={false}>
      {isSmall ? (
        <SimpleList
          primaryText={(r) => `₹${Number(r.amount ?? 0).toLocaleString("en-IN")}`}
          secondaryText={(r) => (r.receivedDate ? formatListDate(String(r.receivedDate)) : "—")}
          tertiaryText={(r) => String(r.reference ?? "—")}
          linkType="edit"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid bulkActionButtons={false} rowClick="edit" sx={{ minWidth: 560 }}>
            <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
            <DisplayDateField source="receivedDate" />
            <TextField source="reference" emptyText="—" />
          </Datagrid>
        </Box>
      )}
    </ReferenceManyField>
  );
};
